import React, { Component } from "react";
import "../css/floorplanImage.css";
import Modal from 'react-modal';
import PlanImageGallery from './PlanImageGallery';
import { PinterestButton } from "react-social";
import { FaPinterest } from 'react-icons/fa';

import ReactGA from 'react-ga';

class FloorplanImage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageArray: [],
            modalIsOpen: false
        }
    }


    render() {
        const image = this.props.image;
        const index = this.props.index;
        const planId = this.props.planId;
        const description = this.props.shortDescription
        const url = 'https://www.houseplanstore.com/plans/types/houseplans/plan/' + planId + '/';

        return (
            <div>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    ariaHideApp={false}
                    //onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    //shouldCloseOnOverlayClick={true}
                    style={{
                        overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
                        content: {
                            zIndex: 9999,
                            top: "60px",
                            left: "0px",
                            right: "0px",
                            bottom: "auto",
                            padding: "0px",
                            border: "none",
                            borderRadius: "none",
                            backgroundColor: "#000"
                        }
                    }}
                    contentLabel="Details"
                >
                    <PlanImageGallery index={index} images={this.state.imageArray} />
                </Modal>
                <div onClick={() => { this.setState({ modalIsOpen: true }) }} className="floorPlanContentHolder">
                    <img className="floorPlanImage" src={image} />
                    <div onClick={() => { this.pinterestShareClicked() }} style={{ position: "absolute", bottom: "4px", right: "4px" }}>
                        <PinterestButton style={{ padding: "0px", height: "30px", width: "30px", backgroundColor: "#E60023", borderRadius: "3px", border: "none" }} url={url} message={description} media={image} >
                            <FaPinterest style={{ marginLeft: "2px", marginRight: "2px", marginTop: "4px", fontSize: "20px", color: "#fff" }} />
                        </PinterestButton>
                    </div>
                </div>
            </div>
        );
    }

    pinterestShareClicked = () => {
        ReactGA.event({
            category: 'User',
            action: 'Pinterest Share Clicked',
            label: this.state.planId
        });
    }

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    }

    startup = () => {
        var images = this.props.images;
        images = images.split(",");
        images.pop();
        var array = [];
        for (var i = 0; i < images.length; i++) {
            array.push({ original: "https://www.houseplanstore.com/media/" + images[i] });
        }
        this.setState({ imageArray: array });
    }

    componentDidMount() {
        this.startup();
    }

}

export default FloorplanImage;